import {httpPost} from "../http/axios";

// 登录
export function signIn(data) {
    return httpPost('/api/common/sign_in', data, '会员签到')
}

// 获取验证码
export function getCode(data) {
    return httpPost('/api/common/sms', data, '获取验证码')
}

// 忘记密码发送短信
export function forgetPsdCode(data) {
    return httpPost('/api/common/retrieve_sms', data, '忘记密码获取验证码')
}

export function userInfo(data) {
    return httpPost('/api/student_center/student_information', data, '个人信息列表')
}

/** 学习统计 */
export function numReport(data) {
    return httpPost('/api/study_report/num_report', data, '一周学习量统计')
}

export function timeReport(data) {
    return httpPost('/api/study_report/time_report', data, '一周学习时间统计')
}

export function monthTime(data) {
    return httpPost('/api/study_report/month_time', data, '本月学习时间')
}

export function testReport(data) {
    return httpPost('/api/study_report/test_report', data, '测试成绩统计')
}

export function totalTestReport(data) {
    return httpPost('/api/study_report/total_test_report', data, '单词量语法量测试统计')
}

/** 首页 */
export function homeIndex(data) {
    return httpPost('/api/student_center/index', data, '首页数据')
}
export function videoList(data) {
    return httpPost('/api/student_center/video_list', data, '视频列表页')
}
export function helpCenter(data) {
    return httpPost('/api/student_center/help_center', data, '帮助中心')
}
export function aboutUs(data) {
    return httpPost('/api/student_center/about_us', data, '关于我们')
}
export function starStudentList(data) {
    return httpPost('/api/student_center/star_student_list', data, '明星学员')
}



